import { render, staticRenderFns } from "./Differentiation.vue?vue&type=template&id=bd22bc1c&"
import script from "./Differentiation.vue?vue&type=script&lang=js&"
export * from "./Differentiation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports